import * as React from "react"
import {useEffect} from "react"
import {useSignal} from "@preact/signals-react";
import {CircularProgress, Grid, Typography} from "@mui/material";
import {CardSeeker} from "@ui-seeker/core";

import MonitoringResultsTableToolbar from "./Toolbar";


export default function MonitoringResultsTableLoadingTab({ title, monitoringTableCountries, monitoringTableCountrySelected }) {
	const dots = useSignal(0)

	useEffect(() => {
		const interval = setInterval(() => {
			if (dots.value < 3)
				dots.value += 1
			else dots.value = 0
		}, 500)

		return () => clearInterval(interval)
	}, []);

	return <CardSeeker
		title={title}
		actions={<MonitoringResultsTableToolbar
			countries={monitoringTableCountries}
			countrySelected={monitoringTableCountrySelected}
		/>}
	>
		<Grid container spacing={2} minHeight={700}>
			<Grid item xs={12} display="flex" flexDirection="column" gap={3} alignItems="center" justifyContent="center">
				<CircularProgress  size={70}/>
				<Typography variant="h5">
					Loading Data. Please Wait{'.'.repeat(dots.value)}
				</Typography>
			</Grid>
		</Grid>
	</CardSeeker>
}